import React, { useEffect, useState, useMemo } from 'react';
import { fetcher } from '../../../../../helpers/fetcher';
// import { fetcherAsync } from '../../../../../helpers/fetcherAsync';
import { configApiLinks } from '../../../../../configApiLinks';
// import { config } from '../../../../../config';

export const useFiscLogs = () => {
  const [modalShow, setModalShow] = useState(false);
  const [fiscLogsList, setFiscLogsList] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [filterDateStart, setFilterDateStart] = useState((new Date()).setDate(new Date().getDate() - 2));
  const [filterDateEnd, setFilterDateEnd] = useState(new Date());

  useEffect(() => {
    if (modalShow === true) {
      getFiscLogs(filterDateStart, filterDateEnd);
    }
  }, [modalShow]);

  const getFiscLogs = (inDateStart, inDateEnd) => {
    if (inDateStart !== filterDateStart) {
      setFilterDateStart(inDateStart);
    }
    if (inDateEnd !== filterDateEnd) {
      setFilterDateEnd(inDateEnd);
    }
    setShowLoader(true);
    fetcher(configApiLinks.getFiscLogs, 'POST', {
      dateStart: Date.parse(inDateStart),
      dateEnd: Date.parse(inDateEnd)
    }).then((data) => {
      if (data?.success) {
        setShowLoader(false);
        setFiscLogsList(data?.data ?? []);
      }
    });
  };

  // here we put
  const delay = (callback, ms) => {
    let timer = 0;
    // return function because keyup require function
    return function () {
      let context = this;
      let args = arguments;
      // if we put something again clear timer (do not wait for result function below) amd start timer again
      clearTimeout(timer);
      timer = setTimeout(function () {
        // runs function on key up ajax send format url etc...
        callback.apply(context, args);
      }, ms);
    };
  };
  return {
    delay,
    fiscLogsList,
    getFiscLogs,
    modalShow,
    showLoader,
    filterDateStart,
    filterDateEnd,
    setModalShow
  };
};
